<svg
  width="53"
  height="41"
  viewBox="0 0 53 41"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [style.color]="color"
>
  <path
    d="M47.9522 0H5.04778C2.27131 0 0 2.23613 0 4.96974V36.0303C0 38.7639 2.27131 41 5.04778 41H47.9522C50.7287 41 53 38.7639 53 36.0303V4.96974C53 2.23613 50.7287 0 47.9522 0ZM47.3214 10.5606L26.5 24.2273L5.67857 10.5606V5.59091L26.5 19.2575L47.3214 5.59091V10.5606Z"
    [attr.fill]="color"
  />
</svg>

<div [style.color]="color">
  {{ content }}
</div>

<ion-button strong (click)="change.emit(true)">
  {{ buttonLabel }}
</ion-button>
